'use client';

import { useLocalStorage } from 'usehooks-ts';
import { createContext } from 'react';

export type GroupOrUserSearch = 'group' | 'user';

interface MultiGroupContextValue {
  groupFilterIds: string[] | null;
  updateGroupFilterIds: (groupIds: string[] | null) => void;
  searchStringFilter: string;
  updateSearchStringFilter: (searchTerm: string) => void;
  searchType: GroupOrUserSearch;
  updateSearchType: (searchType: GroupOrUserSearch) => void;
}

export const ServiceAdminMultiGroupContext =
  createContext<MultiGroupContextValue>({
    groupFilterIds: null,
    updateGroupFilterIds: () => {
      return null;
    },
    searchStringFilter: '',
    updateSearchStringFilter: () => {
      return null;
    },
    searchType: 'user',
    updateSearchType: () => {
      return null;
    },
  });

interface MultiGroupFilteredGroupsContextProviderProps {
  userId: string;
  machineName: string;
  children: React.ReactNode;
}

export const ServiceAdminMultiGroupContextProvider = ({
  userId,
  machineName,
  children,
}: MultiGroupFilteredGroupsContextProviderProps) => {
  const [groupFilterIds, updateGroupFilterIds] = useLocalStorage<
    string[] | null
  >(`serviceAdminGroupFilterIds:${machineName}:${userId}`, []);

  const [searchStringFilter, updateSearchStringFilter] =
    useLocalStorage<string>(
      `serviceAdminSearchString:${machineName}:${userId}`,
      '',
    );

  const [searchType, updateSearchType] = useLocalStorage<GroupOrUserSearch>(
    `serviceAdminSearchToggle:${machineName}:${userId}`,
    'group',
  );

  return (
    <ServiceAdminMultiGroupContext.Provider
      value={{
        groupFilterIds,
        updateGroupFilterIds,
        searchStringFilter,
        updateSearchStringFilter,
        searchType,
        updateSearchType,
      }}
    >
      {children}
    </ServiceAdminMultiGroupContext.Provider>
  );
};
